module.exports = __webpack_public_path__ + "static/media/external-link-hover.f09ec858.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-hover.svg
// module id = 301
// module chunks = 0